module.exports = __webpack_public_path__ + "img/Overview_Banner_Edu-m.695a43ce.png";